import React, { useState, useEffect, useContext } from "react";
import DashboardLayout from "../../layoutcontainers/DashboardLayout";
import { useNavigate } from "react-router-dom";
import AddIcon from "@mui/icons-material/Add";
import { Card, Stack, CardHeader } from "@mui/material";
import MaterialTypography from "../../components/MaterialTypography";
import MaterialButton from "../../components/MaterialButton";
import MaterialDataGrid from "../../components/MaterialDataGrid";
import UserDetailsContext from "../../context/auth";
import { fetchAll } from "../../ApiBaseUrl";
import { useLoading } from "../../context/loading";

const CategoryMaster = () => {
  const navigate = useNavigate();
  const { user, AccessData } = useContext(UserDetailsContext);
  const { circleLoading, setCirleLoading } = useLoading();

  const [categoryList, setCategoryList] = useState([]);

  const categoryTable = {
    columns: [
      {
        field: "name",
        headerName: "Category Name",
        flex: 1,
        disableColumnMenu: true,
        sortable: true,
      },
      {
        field: "description",
        headerName: "Description",
        flex: 1.5,
        disableColumnMenu: true,
        sortable: true,
      },
      { field: "hasPf", headerName: "PF", width: 70, disableColumnMenu: true, sortable: false, align: "center", headerAlign: "center" },
      { field: "hasEsi", headerName: "ESI", width: 70, disableColumnMenu: true, sortable: false, align: "center", headerAlign: "center" },
      { field: "hasBankDetails", headerName: "Bank", width: 70, disableColumnMenu: true, sortable: false, align: "center", headerAlign: "center" },
      { field: "hasHra", headerName: "HRA", width: 70, disableColumnMenu: true, sortable: false, align: "center", headerAlign: "center" },
      { field: "hasShiftPaisa", headerName: "Shift Paisa", width: 95, disableColumnMenu: true, sortable: false, align: "center", headerAlign: "center" },
      { field: "hasOtAmount", headerName: "OT", width: 70, disableColumnMenu: true, sortable: false, align: "center", headerAlign: "center" },
      { field: "hasAttendanceAmount", headerName: "Attend.", width: 80, disableColumnMenu: true, sortable: false, align: "center", headerAlign: "center" },
      { field: "hasBusFare", headerName: "Bus Fare", width: 85, disableColumnMenu: true, sortable: false, align: "center", headerAlign: "center" },
      { field: "hasMealAmount", headerName: "Meal", width: 70, disableColumnMenu: true, sortable: false, align: "center", headerAlign: "center" },
    ],
    rows: categoryList.map((data) => ({
      id: data.id,
      name: data.name,
      description: data.description,
      hasPf: data.hasPf ? "Yes" : "No",
      hasEsi: data.hasEsi ? "Yes" : "No",
      hasBankDetails: data.hasBankDetails ? "Yes" : "No",
      hasHra: data.hasHra ? "Yes" : "No",
      hasShiftPaisa: data.hasShiftPaisa ? "Yes" : "No",
      hasOtAmount: data.hasOtAmount ? "Yes" : "No",
      hasAttendanceAmount: data.hasAttendanceAmount ? "Yes" : "No",
      hasBusFare: data.hasBusFare ? "Yes" : "No",
      hasMealAmount: data.hasMealAmount ? "Yes" : "No",
    })),
  };

  const handleNewCategory = () => {
    navigate("/category/add-category");
  };

  const onRowClick = (e) => {
    if (e?.id) {
      navigate("/category/add-category", { state: e?.id });
    }
  };

  useEffect(() => {
    const fetchCategories = async () => {
      setCirleLoading(true);
      try {
        const fields = [
          "id",
          "name",
          "description",
          "hasPf",
          "hasEsi",
          "hasBankDetails",
          "hasHra",
          "hasShiftPaisa",
          "hasOtAmount",
          "hasAttendanceAmount",
          "hasBusFare",
          "hasMealAmount",
        ];
        const data = await fetchAll("Category", fields);
        setCategoryList(data?.allCategory || []);
      } catch (error) {
        console.error("Error fetching categories:", error);
      } finally {
        setCirleLoading(false);
      }
    };

    fetchCategories();
  }, []);

  return (
    <DashboardLayout>
      <Card>
        <CardHeader
          title={
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
            >
              <Stack direction="column" spacing={0}>
                <MaterialTypography variant="h5" fontWeight="medium">
                  Category List
                </MaterialTypography>
              </Stack>
              <MaterialButton
                variant="gradient"
                color="dark"
                size="small"
                startIcon={<AddIcon />}
                onClick={() => handleNewCategory()}
              >
                Add Category
              </MaterialButton>
            </Stack>
          }
        />
        <MaterialDataGrid
          rows={categoryTable?.rows}
          columns={categoryTable.columns}
          checkboxSelection={false}
          isSelectable={false}
          loading={false}
          onRowClick={onRowClick}
          localeText={{
            noRowsLabel: (
              <Stack
                direction="column"
                alignItems="center"
                justifyContent="center"
                spacing={1}
              >
                <MaterialTypography
                  variant="body2"
                  fontWeight="medium"
                  color="text"
                >
                  No Categories found
                </MaterialTypography>
                <MaterialTypography variant="caption" color="text">
                  Click on "Add Category" to create a new category.
                </MaterialTypography>
              </Stack>
            ),
          }}
        />
      </Card>
    </DashboardLayout>
  );
};

export default CategoryMaster;
